import React from "react"
import Checkboxes from "./Checkboxes"
import "./Section.07.Aid.css"

export default function AidSection(params) {

    const {rescue, values} = params
    
    return <li className="accordion">
        <input type="checkbox" className="accordion" name="accordion" id="acc-aid"/>
        <label className="accordion" htmlFor="acc-aid">Pružena pomoć i transport</label>
        <section className="accordion">        
      		<div className="field full">
      			<label className="above" htmlFor="treatment_desc">Pružena pomoć</label>
      			<Checkboxes values={values?.treatments} selected={rescue.rescue.treatment} onChange={list => rescue.setField("treatment", list)}/>
      			<input type="text" value={rescue.rescue.treatment_desc || ''} id="treatment_desc" className="underline" placeholder="Ukucaj slovima ovde ako nije ponuđeno..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
        	</div>
        	
        	<div className="field full">
      			<label className="above" htmlFor="transport_desc">Transport</label>	
      			<Checkboxes values={values?.transports} selected={rescue.rescue.transport} onChange={list => rescue.setField("transport", list)}/>
      			<input type="text" value={rescue.rescue.transport_desc || ''} id="transport_desc" className="underline" placeholder="Ako nema ponuđeno, upiši sam ovde..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
      		</div>          		
        </section>
    </li>
    
}